import React, { useRef, useEffect } from 'react';
import { images } from '../shared/assets';
import { initializeDragScroll } from '../../utils/interactiveFeatures';
import { useTranslation } from '../../i18n';
import './TeamMembersCarousel.css';

interface TeamMember {
  name: string;
  role: string;
  property: string;
  description: string;
  image: string;
}

const teamMembers: TeamMember[] = [
  {
    name: "Marco Salinas",
    role: "HEAD CHEF",
    property: "AWASI PATAGONIA",
    description: "The remoteness encourages the use of local ingredients. From the the icy seas and lakes to the west, to the wild herbs and native produce foraged across the Patagonian plains.",
    image: images.ourStoryTeamMarco
  },
  {
    name: "Paula Bertotto",
    role: "EXPERIENCE MANAGER",
    property: "AWASI IGUAZÚ",
    description: "I believe it's essential to find ways to surprise our guests by unveiling the unexpected secrets that nature and culture hold, making the experience truly unforgettable.",
    image: images.ourStoryTeamPaula
  },
  {
    name: "Juan Ignacio García Machicao",
    role: "EXCURSIONS MANAGER",
    property: "AWASI ATACAMA",
    description: "Thanks to the high level of service that defines us, I have grown as a professional, and it is an honour to lead the excursions team today.",
    image: images.ourStoryTeamJuan
  },
  {
    name: "Florencia Lavagno",
    role: "ASSISTANT MANAGER",
    property: "AWASI PATAGONIA",
    description: "Patagonia is, without a doubt, my place in the world. Living and working here allows me to share my love for this region with others.",
    image: images.ourStoryTeamMarco // Placeholder - replace with actual image
  }
];

export const TeamMembersCarousel: React.FC = () => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const containerRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (scrollRef.current) {
      // Initialize drag scroll functionality
      const cleanup = initializeDragScroll('team-members-carousel');
      
      return () => {
        if (cleanup) cleanup();
      };
    }
  }, []);

  const scrollCarousel = () => {
    if (scrollRef.current) {
      const cardWidth = 433; // Width of each card including gap
      scrollRef.current.scrollBy({ left: cardWidth, behavior: 'smooth' });
    }
  };

  return (
    <div className="team-members-carousel" ref={containerRef}>
      <div className="team-members-header">
        <h1>+300 people, +17 nationalities, Uncountable talents</h1>
        <div className="team-members-intro">
          <p>
            Our staff create first impressions, accompany our guests on their adventures and strive to exceed expectations — sending them home with unforgettable memories. Our team is made of passionate people who are proud ambassadors of these lands. Each of them is a key component of the Awasi Lodges. We are forever grateful to the #AwasiFamily.
          </p>
          <button className="join-team-btn">
            <span>JOIN OUR TEAM</span>
          </button>
        </div>
      </div>

      <div className="team-members-carousel-wrapper">
        <div 
          ref={scrollRef}
          className="team-members-scroll-container"
          id="team-members-carousel"
        >
          {teamMembers.map((member, index) => (
            <div key={index} className="team-member-card">
              <img src={member.image} alt={t('accessibility.images.teamMember') + ': ' + member.name} />
              <div className="team-member-info">
                <h3>{member.name}</h3>
                <span className="team-role">{member.property} - {member.role}</span>
                <p>{member.description}</p>
                <a href="/our-story" className="awasi-link awasi-link--read-more">
                  <span className="awasi-link-text">READ MORE</span>
                  <div className="awasi-link-underline">
                    <svg viewBox="0 0 76 2" fill="none">
                      <path d="M0 1L76 1" />
                    </svg>
                  </div>
                </a>
              </div>
            </div>
          ))}
        </div>
        
        {/* Navigation Arrow */}
        <button 
          className="team-carousel-arrow"
          onClick={scrollCarousel}
          aria-label={t('accessibility.buttons.scrollRight')}
          type="button"
        >
          <img src={images.navigation.teamCarouselArrow} alt="" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
};

export default TeamMembersCarousel;